<div class="footer">

    <div class="d-flex flex-column marginCls mb-2 mt-4">
        <div class="d-flex flex-row mobile-column align-items-center pt-4 pb-4 mb-4 border-top border-bottom">
            <div class="col">
                <a (click)="navigateToWordpress()"><img src="assets/images/footer-logo.png" class="img-fluid"></a>
            </div>
            <div class="col">
                <div class="d-flex justify-content-end flex-grow-1 align-items-center mobileFtrSocial">
                    <ul class="list-unstyled list-inline text-end mb-0 me-3">
                        <li class="list-inline-item">
                            <a class="no-shadow mx-1 fb-icon-footer" href="https://www.facebook.com/edgebuildings"
                                target="_blank">
                                <svg>
                                    <use xlink:href="assets/images/icons/symbol-defs.svg#fb-icon"></use>
                                </svg>
                            </a>
                        </li>
                        <li class="list-inline-item">
                            <a class="no-shadow mx-1 yt-icon-footer"
                                href="https://www.youtube.com/channel/UC_A9PJ_6HmzHOyxgeOk-1Qw" target="_blank">
                                <svg>
                                    <use xlink:href="assets/images/icons/symbol-defs.svg#yt-icon"></use>
                                </svg>
                            </a>
                        </li>
                        <li class="list-inline-item">
                            <a class="no-shadow mx-1 twtr-icon-footer" href="https://twitter.com/edgebuildings"
                                target="_blank">
                                <svg>
                                    <use xlink:href="assets/images/icons/symbol-defs.svg#twitter-icon"></use>
                                </svg>
                            </a>
                        </li>
                        <!-- <li class="list-inline-item">
                          <a class="btn-floating background-doggerblue rounded-sm no-shadow mx-1">
                            <i class="fab fa-google-plus"></i>
                          </a>
                        </li> -->
                        <li class="list-inline-item">
                            <a class="no-shadow mx-1 lnkdn-icon-footer"
                                href="https://www.linkedin.com/company/edgebuildings/" target="_blank">
                                <svg>
                                    <use xlink:href="assets/images/icons/symbol-defs.svg#linkedin-icon"></use>
                                </svg>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="d-flex flex-row align-items-center">
            <div class="">
                <div class="d-flex flex-column text-black-opacity-point6">
                    <small class="footer-text">{{userPersistenceService.generalTranslation.Copyright}}</small>
                    <small class="footer-text">{{userPersistenceService.generalTranslation.Trademark}}</small>
                </div>
            </div>
            <div class="d-flex justify-content-end flex-grow-1">
                <div class="d-flex flex-column shotLInks">
                    <small><a href="https://www.edgebuildings.com/" target="_blank"
                            class="text-black-opacity-point6 footer-text cursor-pointer"
                            title="Edgebuildings.com">edgebuildings.com</a> </small>
                    <small><a href="javascript:void(0);" class="text-black-opacity-point6 footer-text cursor-pointer"
                            [title]="userPersistenceService.generalTranslation.FeedBack"
                            (click)="feedback()">{{userPersistenceService.generalTranslation.FeedBack}}</a></small>
                    <small><a href="https://www.edgebuildings.com/contact-us/privacy/" target="_blank"
                            class="text-black-opacity-point6 footer-text cursor-pointer"
                            [title]="userPersistenceService.generalTranslation.Privacy">{{userPersistenceService.generalTranslation.Privacy}}</a></small>
                    <small><a href="https://www.edgebuildings.com/contact-us/terms-of-use/" target="_blank"
                            class="text-black-opacity-point6 footer-text cursor-pointer"
                            [title]="userPersistenceService.generalTranslation.TermsofUse">{{userPersistenceService.generalTranslation.TermsofUse}}</a></small>
                    <small><a openLinkInNewWindow routerLink="/release-info"
                            class="text-black-opacity-point6 footer-text cursor-pointer"
                            [title]="userPersistenceService.generalTranslation.ReleaseNote">{{userPersistenceService.generalTranslation.ReleaseNote}}</a></small>
                </div>
            </div>
        </div>
    </div>


</div>